import "./Modal.css";

export default function Modal({ content, onClose }) {
  return (
    <div className="overlay">
      <div className="modal">
        <div className="modal-wrapper">
          <button className="close-button" onClick={onClose}>
            <svg width="98" height="96" viewBox="0 0 98 96" className="close-button-svg" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
              <rect width="115.92" height="17.889" rx="8.94448" transform="matrix(-0.696845 0.717222 0.717222 0.696845 83.1709 0)" fill="currentColor"></rect>
              <rect width="115.92" height="17.889" rx="8.94448" transform="matrix(0.73406 0.679084 0.679084 -0.73406 0 13.1318)" fill="currentColor"></rect>
            </svg>
          </button>
          {content}
        </div>
      </div>
    </div>
  );
}